export default "__VITE_ASSET__B4zE5rOf__"